'use client' // Error components must be Client Components
import { useEffect } from 'react'
import { LANG } from '@/utils'

const FALLBACK_COPY_BY_LANG = {
  en: {
    title: 'Something went wrong',
    description: 'An unexpected error occurred while loading this page.',
    cta: 'Try again'
  },
  es: {
    title: 'Algo fue mal',
    description: 'Ha ocurrido un error inesperado al cargar esta página.',
    cta: 'Intentar de nuevo'
  }
} as const

export default function Error({ error, reset }: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const fallbackCopy = LANG === 'es' ? FALLBACK_COPY_BY_LANG.es : FALLBACK_COPY_BY_LANG.en

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <div>
      <h2>{fallbackCopy.title}</h2>
      <p>{fallbackCopy.description}</p>
      <button onClick={() => reset()}>{fallbackCopy.cta}</button>
    </div>
  )
}
